import React, { useMemo, useState } from 'react';
import { DOWNLOAD_DISK_O_PROMO_CONFIG } from 'reactApp/appHelpers/configHelpers';
import { DEMO_PROMO_VARIANT } from 'reactApp/appHelpers/featuresHelpers/features/demoPromo';
import { unlimitedDocsFakedoorConfig } from 'reactApp/appHelpers/featuresHelpers/features/unlimitedDocuments';
import { DemoPromo } from 'reactApp/ui/DemoPromo/DemoPromo';
import { useDiscountTimer } from 'reactApp/ui/DiscountInOutflow/DiscountTimer/useDiscountTimer';
import { TrialPromo } from 'reactApp/ui/TrialPromo/TrialPromo';
import { UnlimitedDocumentsBanner } from 'reactApp/ui/UnlimitedDocuments/UnlimitedDocumentsBanner/UnlimitedDocumentsBanner';
import { useUnlimitedDocumentsBanner } from 'reactApp/ui/UnlimitedDocuments/UnlimitedDocumentsBanner/useUnlimitedDocumentsBanner';

import { useShow1tbPromo } from './useShow1tbPromo';

export const useLeftBlockTopPromo = () => {
    const show1tbTrialPromo = useShow1tbPromo();
    const [isLeftBlockTopPromoVisible, setIsLeftBlockTopPromoVisible] = useState(true);
    const { isLoaded: isDiscountTimerShowInfoLoaded, element: timerElement } = useDiscountTimer(setIsLeftBlockTopPromoVisible);
    const { show: showUnlimitedDocumentsBanner } = useUnlimitedDocumentsBanner();

    const isLoaded = isDiscountTimerShowInfoLoaded;

    const leftBlockTopPromo = useMemo(() => {
        if (!isLoaded) {
            return null;
        }
        // тут должны быть либо статические условия, либо надо проверить их актуальность через isLoaded,
        // чтобы заранее не отрендерить элемент ниже в очереди, пока условие временно будет false
        switch (true) {
            case showUnlimitedDocumentsBanner:
                return <UnlimitedDocumentsBanner type={unlimitedDocsFakedoorConfig.type} setVisible={setIsLeftBlockTopPromoVisible} />;
            case !!DEMO_PROMO_VARIANT:
                return <DemoPromo setVisible={setIsLeftBlockTopPromoVisible} />;
            case !!timerElement:
                return timerElement;
            case show1tbTrialPromo:
                return (
                    <TrialPromo
                        text="+1 ТБ на месяц бесплатно"
                        href={DOWNLOAD_DISK_O_PROMO_CONFIG?.treePromoLink}
                        setVisible={setIsLeftBlockTopPromoVisible}
                    />
                );
            default:
                return null;
        }
    }, [isLoaded, show1tbTrialPromo, timerElement, showUnlimitedDocumentsBanner]);

    return { leftBlockTopPromo, isLeftBlockTopPromoVisible };
};
